import { Button } from "antd";
import styles from "./subStatusButton.module.scss";
import { IncomingTransitionIcon } from "../../incomingTransitionIcon/incomingTransitionIcon";
import { OutgoingTransitionIcon } from "../../outgoingTransitionIcon/outgoingTransitionIcon";
import { DisabledSubStatusIcon } from "../../disabledSubStatusIcon/disabledSubStatusIcon";

export const SUB_STATUS_TYPES = {
  SELECTED: "selected",
  INCOMING: "incoming",
  OUTGOING: "outgoing",
  DISABLED: "disabled",
  DEFAULT: "default",
};

const SUB_STATUS_CONFIG = {
  [SUB_STATUS_TYPES.SELECTED]: {
    className: styles.selectedSubStatus,
    icon: null,
  },
  [SUB_STATUS_TYPES.INCOMING]: {
    className: styles.incomingSubStatus,
    icon: <IncomingTransitionIcon />,
  },
  [SUB_STATUS_TYPES.OUTGOING]: {
    className: styles.outgoingSubStatus,
    icon: <OutgoingTransitionIcon />,
  },
  [SUB_STATUS_TYPES.DISABLED]: {
    className: styles.disabledSubStatus,
    icon: <DisabledSubStatusIcon />,
  },
  [SUB_STATUS_TYPES.DEFAULT]: {
    className: "",
    icon: null,
  },
};

export const SubStatusButton = ({ name, type, onClick }) => {
  const config = SUB_STATUS_CONFIG[type];

  return (
    <Button
      type="text"
      onClick={onClick}
      className={`${styles.subStatusButton} ${config.className}`}
    >
      {name} {config.icon}
    </Button>
  );
};
